'use strict';

/**
 * Validate a jQuery input element value.
 *
 * - Reads the input value, trims whitespace, and validates presence.
 * - If a `pattern` attribute is present it will be used as a RegExp to validate the value.
 * - On validation failure the function writes an error message into the sibling `.custom-feedback` element.
 *
 * @param {jQuery} $this - jQuery-wrapped input element to validate. Must implement `.val()`, `.data()`, `.attr()`.
 * @returns {boolean} Returns `true` when the input is invalid (has an error), `false` when valid.
 */
function inputValidation($this) {
    const value = $this.val().trim();
    const missingError = $this.data('missing-error');

    if (value === '') {
        $this.siblings('.custom-feedback').text(missingError);
        return true;
    }

    if ($this.attr('type') === 'checkbox' && !$this.prop('checked')) {
        $this.siblings('.custom-feedback').text(missingError);
        return true;
    }

    const patternStr = $this.attr('pattern');
    if (patternStr) {
        let pattern;
        try {
            pattern = new RegExp(patternStr);
        } catch (e) {
            pattern = null;
        }

        if (pattern && !pattern.test(value)) {
            const parseError = $this.data('parse-error');
            $this.siblings('.custom-feedback').text(parseError);
            return true;
        }
    }

    $this.siblings('.custom-feedback').text('');
    return false;
}

module.exports = {
    inputValidation: inputValidation
};
